export default {
    serverUrl: process.env.MIX_BACKEND_URL,
    defaultLanguage: process.env.MIX_DEFAULT_LANGUAGE,
    kycFileSizeMax: process.env.MIX_KYC_FILE_SIZE_MAX,
    payPalLoginLink: process.env.MIX_PAY_PAL_LOGIN_LINK,
    recaptchaClientKey: process.env.MIX_RECAPTCHA_CLIENT_KEY
}
